module.exports = __webpack_public_path__ + "img/avatar-56.f621f9e4.png";